import { useCallback, useState } from "react";
import { BETA_NOTICE } from "@/lib/copy";

/* ============================================================
   useBetaNotice — dismissal state for the beta-notice banner.

   Persists a single sentinel under a version-keyed localStorage
   entry (BETA_NOTICE.versionKey). Bumping that key in copy.ts
   resurfaces the banner for everyone after a meaningful release.

   localStorage access is try/catch-guarded (private mode, quota,
   storage disabled) following the useTweaks pattern. If storage
   is unavailable the banner simply shows again next session.
   ============================================================ */

const STORAGE_KEY = BETA_NOTICE.versionKey;

export function useBetaNotice(): { dismissed: boolean; dismiss: () => void } {
  const [dismissed, setDismissed] = useState<boolean>(hydrate);

  const dismiss = useCallback(() => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, "dismissed");
    } catch {
      /* storage unavailable — dismissal will not persist */
    }
  }, []);

  return { dismissed, dismiss };
}

function hydrate(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    /* storage unavailable */
    return false;
  }
}
